import graphqlClient from '~/graphql/graphqlClient';

export type CavernsUpdateUnitsArgs = {
  playerId: string;
  game_submode: string;
  allUnits: any;
  allTiles?: any;
};

export type CavernsUpdateUnitsResult = {
  success: boolean;
};

const mutation = `
mutation CavernsUpdateUnits(
  $playerId: String!
  $game_submode: String!
  $allUnits: JSON!
  $allTiles: JSON
) {
  cavernsUpdateUnits(
    playerId: $playerId
    game_submode: $game_submode
    allUnits: $allUnits
    allTiles: $allTiles
  ) {
    success
  }
}`;

export default async function mutationCavernsUpdateUnits(
  args: CavernsUpdateUnitsArgs
): Promise<CavernsUpdateUnitsResult | undefined> {
  return await graphqlClient.request<CavernsUpdateUnitsResult>('cavernsUpdateUnits', mutation, args);
}
